<template>
  <div :class="['w-full mx-auto px-4', theme.middleScreen.backgroundColor]">
    <form class="w-full pt-6">
      <div
        v-show="menu.show_number_of_guests"
        class="flex flex-wrap -mx-3 mb-2"
      >
        <div class="w-full px-3">
          <label
            :class="[
              'block uppercase tracking-wide text-xs font-bold mb-2',
              theme.body.textColor,
            ]"
            for="full-name"
            >{{ lang["number_of_guests"][language] }}</label
          >
          <div
            :class="[
              'flex flex-row h-8 rounded-lg relative bg-transparent justify-center items-center rounded-2large border-white w-1/5 shadow-lg transition duration-500  hover:shadow-xl',
              theme.addToCart.backgroundColorMinus,
            ]"
          >
            <button
              @click="removeFromNumberOfGuests()"
              type="button"
              :class="[
                theme.addToCart.backgroundColorMinus,
                'fill-current focus:outline-none inline-block h-6 w-6 rounded-full m-2',
                theme.addToCart.textColorPlus,
              ]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M20 12H4"
                />
              </svg>
            </button>
            <input
              type="number"
              readonly
              :class="[
                theme.body.backgroundColor,
                theme.body.textColor,
                'focus:outline-none text-center h-8 w-6 text-md md:text-basecursor-default flex items-center outline-none w-full justify-center',
              ]"
              name="custom-input-number"
              :value="numberOfGuests"
            />
            <button
              @click="addToNumberOfGuests()"
              type="button"
              :class="[
                theme.addToCart.backgroundColorPlus,
                'h-6 w-6 rounded-full cursor-pointer focus:outline-none m-2',
                theme.addToCart.textColorPlus,
              ]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full px-3">
          <label
            :class="[
              'block uppercase tracking-wide text-xs font-bold mb-2',
              theme.body.textColor,
            ]"
            for="full-name"
            >{{ lang["full_name"][language] }}</label
          >
          <input
            :class="[
              'appearance-none block w-full rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none focus:border-gray-500 shadow-lg transition duration-500  hover:shadow-xl',
              theme.body.textColor,
              theme.body.backgroundColor,
            ]"
            id="full-name"
            v-model="fullName"
            type="text"
            placeholder="John Doe"
          />
        </div>
      </div>
      <div v-show="homeDelivery">
        <div class="flex flex-wrap -mx-3 mb-2">
          <div class="w-full px-3">
            <label
              :class="[
                'block uppercase tracking-wide text-xs font-bold mb-2',
                theme.body.textColor,
              ]"
              for="full-name"
              >{{ lang["address"][language] }}</label
            >
            <input
              :class="[
                'appearance-none block w-full rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none focus:border-gray-500 shadow-lg transition duration-500  hover:shadow-xl',
                theme.body.textColor,
                theme.body.backgroundColor,
              ]"
              id="address"
              v-model="address"
              type="text"
              placeholder="Saint Napoleon 6"
              v-on:input="addAddress($event)"
            />
          </div>
        </div>
        <div v-show="menu.enable_delivery">
          <div class="flex flex-wrap -mx-3 mb-2">
            <div class="w-full px-3">
              <label
                :class="[
                  'block uppercase tracking-wide text-xs font-bold mb-2',
                  theme.body.textColor,
                ]"
                for=""
                >{{ lang["zip"][language] }}</label
              >
              <input
                :class="[
                  'appearance-none block w-full rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none focus:border-gray-500 shadow-lg transition duration-500  hover:shadow-xl',
                  theme.body.textColor,
                  theme.body.backgroundColor,
                ]"
                id="zip"
                v-model="zip"
                type="text"
                placeholder="John Doe"
                v-on:input="addAddress($event)"
              />
            </div>
          </div>
          <div class="flex flex-wrap -mx-3 mb-2">
            <div class="w-full px-3">
              <label
                :class="[
                  'block uppercase tracking-wide text-xs font-bold mb-2',
                  theme.body.textColor,
                ]"
                for=""
                >{{ lang["city"][language] }}</label
              >
              <input
                :class="[
                  'appearance-none block w-full rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none focus:border-gray-500 shadow-lg transition duration-500  hover:shadow-xl',
                  theme.body.textColor,
                  theme.body.backgroundColor,
                ]"
                id="city"
                v-model="city"
                type="text"
                placeholder="John Doe"
                v-on:input="addAddress($event)"
              />
            </div>
          </div>
          <div class="flex flex-wrap -mx-3 mb-2">
            <div class="w-full px-3">
              <label
                :class="[
                  'block uppercase tracking-wide text-xs font-bold mb-2',
                  theme.body.textColor,
                ]"
                for=""
                >{{ lang["country"][language] }}</label
              >
              <input
                :class="[
                  'appearance-none block w-full rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none focus:border-gray-500 shadow-lg transition duration-500  hover:shadow-xl',
                  theme.body.textColor,
                  theme.body.backgroundColor,
                ]"
                id="country"
                v-model="country"
                type="text"
                placeholder="John Doe"
                v-on:input="addAddress($event)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full px-3">
          <label
            :class="[
              'block uppercase tracking-wide text-xs font-bold mb-2',
              theme.body.textColor,
            ]"
            for="email"
            >{{ lang["email"][language] }}</label
          >
          <input
            :class="[
              'appearance-none block w-full rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none shadow-lg transition duration-500  hover:shadow-xl',
              theme.body.textColor,
              theme.body.backgroundColor,
            ]"
            id="email"
            v-model="email"
            type="email"
            placeholder="john@example.com"
          />
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full px-3">
          <label
            :class="[
              'block uppercase tracking-wide text-xs font-bold mb-2',
              theme.body.textColor,
            ]"
            for="phone"
            >{{ lang["phone"][language] }}</label
          >
          <input
            :class="[
              'appearance-none block w-full rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none shadow-lg transition duration-500  hover:shadow-xl',
              theme.body.textColor,
              theme.body.backgroundColor,
            ]"
            id="phone"
            v-model="phone"
            type="text"
            placeholder="0xx xxxxxxx"
          />
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full px-3">
          <label
            :class="[
              'block uppercase tracking-wide text-xs font-bold mb-2',
              theme.body.textColor,
            ]"
            for="note"
            >{{ lang["note_label"][language] }}</label
          >
          <textarea
            v-model="note"
            id="note"
            rows="4"
            maxlength="150"
            :class="[
              'appearance-none block w-full rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none shadow-lg transition duration-500  hover:shadow-xl',
              theme.body.backgroundColor,
              theme.body.textColor,
            ]"
          ></textarea>
        </div>
      </div>
      <div
        class="flex flex-wrap -mx-3 mb-2"
        v-show="
          calculatedDistanceHomeDelivery > this.menu.max_delivery_distance ||
          calculatedDistanceHomeDelivery == 0 && this.menu.enable_delivery==true && homeDelivery
        "
      >
        <div class="w-full px-3">
          <label
            :class="[
              'block uppercase tracking-wide text-xs font-bold mb-2 text-red-600 mb-10',
              theme.body.textColor,
            ]"
            for="note"
            >{{ lang["DeliveryDistanceOutOfRange"][language] }}</label
          >
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  data() {
    return {
      lang: lang,
    };
  },
  computed: {
    ...mapGetters([
      "language",
      "menuHash",
      "theme",
      "menu",
      "calculatedDistanceHomeDelivery",
      "address"
    ]),
    ...mapGetters("Cart", ["numberOfGuests", "tableId", "homeDelivery"]),
    fullName: {
      get() {
        if (this.$cookies.isKey("n")) {
          return this.$aes.decrypt(decodeURI(this.$cookies.get("n")));
        }
        return this.$store.getters["Cart/customer"]["fullName"];
      },
      set(value) {
        this.$store.commit("Cart/updateCustomer", {
          field: "fullName",
          value: value,
        });
      },
    },
    address: {
      get() {
        if (this.$cookies.isKey("a")) {
          return this.$aes.decrypt(decodeURI(this.$cookies.get("n")));
        }
        return this.$store.state.address
      },
      set(value) {
        this.$store.commit("updateAddress",value);
      }
    },
    email: {
      get() {
        if (this.$cookies.isKey("e")) {
          return this.$aes.decrypt(decodeURI(this.$cookies.get("e")));
        }
        return this.$store.getters["Cart/customer"]["email"];
      },
      set(value) {
        this.$store.commit("Cart/updateCustomer", {
          field: "email",
          value: value,
        });
      },
    },
    city: {
      get() {
        if (this.$cookies.isKey("c")) {
          return this.$aes.decrypt(decodeURI(this.$cookies.get("c")));
        }
        return this.$store.state.city
      },
      set(value) {
        this.$store.commit("updateCity",value)
      },
    },
    country: {
      get() {
        if (this.$cookies.isKey("co")) {
          return this.$aes.decrypt(decodeURI(this.$cookies.get("co")));
        }
        return this.$store.state.country
      },
      set(value) {
        this.$store.commit("updateCountry",value)
      },
    },
    zip: {
      get() {
        if (this.$cookies.isKey("z")) {
          return this.$aes.decrypt(decodeURI(this.$cookies.get("z")));
        }
        return this.$store.state.zip
      },
      set(value) {
        this.$store.commit("updateZip",value);
      },
    },
    phone: {
      get() {
        if (this.$cookies.isKey("p")) {
          return this.$aes.decrypt(decodeURI(this.$cookies.get("p")));
        }
        return this.$store.getters["Cart/customer"]["phone"];
      },
      set(value) {
        this.$store.commit("Cart/updateCustomer", {
          field: "phone",
          value: value,
        });
      },
    },
    note: {
      get() {
        return this.$store.getters["Cart/note"];
      },
      set(value) {
        this.$store.commit("Cart/updateNote", value);
      },
    },
  },
  methods: {
    removeItem(item) {
      this.$store
        .dispatch("Cart/UPDATE_ORDER", { operation: "remove", item: item })
        .then(() => {})
        .catch(() => {});
    },
    removeFromNumberOfGuests() {
      this.$store.commit("Cart/updateNumberOfGuests", -1);
    },
    addToNumberOfGuests() {
      this.$store.commit("Cart/updateNumberOfGuests", 1);
    },
    addAddress: _.debounce(function () {
      this.$store.dispatch(
        "GET_LAT_LONG_ADDRESS",
        this.$store.state.address +
          "%20" +
          this.$store.state.zip +
          "%20" +
          this.$store.state.city +
          "%20" +
          this.$store.state.country
      );
    }, 1000),
  },
  created() {
    this.$aes.setKey("W6{/}m>UU;Kh::+)");
  },
  mounted() {
    if (!this.menuHash) {
      if (localStorage.getItem("stickerId") == 0) {
        this.$router.push(`/${this.$route.params.menuHash}`).catch(() => {});
      } else {
        this.$router
          .push(
            `/${this.$route.params.menuHash}/` +
              localStorage.getItem("stickerId")
          )
          .catch(() => {});
      }
    }
  },
};
</script>